import { create } from 'zustand';
import type { UserRecord, SubscriptionRecord, UsageCheckResult } from '../types';

interface AuthState {
  user: UserRecord | null;
  subscription: SubscriptionRecord | null;
  usage: { voice: UsageCheckResult; email: UsageCheckResult } | null;
  setUser: (user: UserRecord | null) => void;
  setSubscription: (sub: SubscriptionRecord | null) => void;
  setUsage: (
    usage: { voice: UsageCheckResult; email: UsageCheckResult } | null,
  ) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  subscription: null,
  usage: null,
  setUser: (user) => set({ user }),
  setSubscription: (subscription) => set({ subscription }),
  setUsage: (usage) => set({ usage }),
}));
